<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="grid" *ngIf="carInformacionInicial">
      <div class="col-12 md:col-12 lg:col-12 text-center">
        <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
        <span>{{'LBL_CONSULTANDO' | translate }}</span>
      </div>
    </div>
    <div *ngIf="!carInformacionInicial">
      <div class="grid">
        <div class="col-12 md:col-12">
          <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
            <p-accordionTab header="{{'GRUPO.LBL_GRUPOS' | translate}}"
                            [selected]="tabSeleccionado === 'GRUPOS'">
              <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fGrupos" name="fGrupos">
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-6">
                    <div class="div-form">
                      <label>* {{ 'GRUPO.LBL_CODIGOGRUPO' | translate }}</label>
                      <input type="text" pInputText id="codigo"
                             name="nomCodigo"
                             autocomplete="off"
                             formControlName="codigo"
                             [maxlength]="6" (blur)="validarCodigo()"
                             codigos-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf=" submitted && f.codigo.invalid">
                        {{ 'GRUPO.LBL_CODIGOGRUPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                        {{ 'MSG_CODIGOEXISTE' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-12 lg:col-6">
                    <div class="div-form">
                      <label>* {{ 'GRUPO.LBL_NOMBREGRUPO' | translate }}</label>
                      <input type="text" pInputText id="nombre"
                             name="nomNombre"
                             autocomplete="off"
                             formControlName="nombre"
                             capitalize-reactive
                             [maxlength]="50"

                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                        {{ 'GRUPO.LBL_NOMBREGRUPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'GRUPO.LBL_DESCRIPCION' | translate }}</label>
                      <input type="text" pInputText id="descripcion"
                             name="nomDescripcion"
                             autocomplete="off"
                             formControlName="descripcion"
                             [maxlength]="500"

                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                        {{ 'GRUPO.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="grid form-group">
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <label>* {{ 'GRUPO.LBL_GERENTEOFICINA' | translate }}</label>
                      <p-dropdown disableTab  id="idUsuario" name="nomIdUsuario" [options]="lisGerentesOficina"
                                  placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                   formControlName="idUsuario"
                      ></p-dropdown>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idUsuario.invalid">
                        {{ 'GRUPO.LBL_GERENTEOFICINA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="false"
                                  id="indicadorHabilitado"
                                  name="nomindicadorHabilitado"
                                  formControlName="indicadorHabilitado"></p-checkbox>
                    </div>
                  </div>
                </div>

                <div class="grid form-footer-buttons">
                  <div class="form-group col-12">
                    <div *ngIf="!guardando">
                      <a (click)="regresar( formulario.dirty )" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                              type="submit"
                              pButton></button>
                    </div>
                    <div *ngIf="guardando">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </form>
            </p-accordionTab>
            <p-accordionTab  header="{{ 'GRUPO.LBL_ASIGNARZONAS' | translate }}"
                             [disabled]="!grupo"
                             [selected]="tabSeleccionado === 'ZONAS'">
              <app-grupo-zona [grupo]="grupo" *ngIf="grupo && !!grupo.idGrupo"></app-grupo-zona>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="asignar-grupos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
